import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserEffects } from './user.effects';
import { authReducer, USER_KEY } from './user.reducer';

@NgModule({
  imports: [StoreModule.forFeature(USER_KEY, authReducer), EffectsModule.forFeature([UserEffects])],
})
export class UserStateModule {}
